import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";
import Signin from "./pages/Signin2";
import ProtectedRoute from "./components/ProtectedRoute";
import OtpAuthentication from "./apps/validationOTP";

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";
import ImportDetails from "./apps/ImportDetails";
import EntiteDetails from "./apps/EntiteDetails";

import "./assets/css/remixicon.css";
import "./scss/style.scss";

import { TokenProvider } from './context/TokenContext';
import TokenExpiryWarning from "./components/TokenExpiryWarning"; // ← Importer le composant
import Logs from "./apps/Logs";

// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {
  return (
    <React.Fragment>
      <TokenProvider>
        <BrowserRouter>
          {/* ✅ Afficher le modal d'alerte globalement */}
          <TokenExpiryWarning />
          
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard/analytics" replace />} />
            <Route path="/login" element={<Signin />} />
            <Route path="/apps/validationOTP" element={<OtpAuthentication />} />

            {publicRoutes.map((route, index) => (
              <Route
                path={route.path}
                element={route.element}
                key={`public-${index}`}
              />
            ))}

            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Main />
                </ProtectedRoute>
              }
            >
              {protectedRoutes.map((route, index) => (
                <Route
                  path={route.path}
                  element={route.element}
                  key={`protected-${index}`}
                />
              ))}
              <Route path="/apps/import-details/:bulkId" element={<ImportDetails />} />
              <Route path="/apps/entite/details/:id" element={<EntiteDetails />} />

              <Route path="/apps/Logs" element={<Logs />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TokenProvider>
    </React.Fragment>
  );
}